<template>
  <div>
    <el-card style="border-radius: 40px">
      <div class="tui-tab">
        <div
          class="tui-tab-item"
          v-for="(item, index) in tabs"
          :key="index"
          :class="currentIndex == index ? 'tui-active' : ''"
          @click="onClickTabs(index)"
        >
          <i
            :class="item.icon"
            :style="{ color: currentIndex == index ? '#5474e6' : '' }"
          ></i>
          {{ item.name }}
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="flex-between">
        <div class="tui-title" v-if="!listInfo.TypeName">
          {{ listInfo.GradeName }} {{ listInfo.ClassName }}
        </div>
        <div class="tui-title" v-if="listInfo.TypeName == '班级相册'">
          班级相册
        </div>
        <div class="flex" v-if="currentIndex != 2 && currentIndex != 3">
          <el-button
            type="goon"
            v-if="checkArr.length != 0"
            @click="downloadAllImage"
            >批量下载</el-button
          >

          <el-button
            type="danger"
            v-if="checkArr.length != 0"
            @click="batchRemoveFolder"
            >批量删除</el-button
          >

          <el-button
            type="goon"
            @click="addElseFolder"
            v-if="checkArr.length != 0"
            >添加到</el-button
          >

          <el-button
            type="goon"
            v-if="checkArr.length != 0 && FolderOneIndex != -0.1"
            @click="shiftOutMore"
            >移出</el-button
          >

          <el-button type="goon" @click="addFolder">新建文件夹</el-button>
        </div>
      </div>
      <!-- tab -->
      <div class="tui-list" v-if="currentIndex != 2 && currentIndex != 3">
        <div
          class="tui-list-item"
          :style="{ background: FolderOneIndex == item.Id ? '#EAEAEA' : '' }"
          v-for="(item, index) in folderList"
          @click="onClickInfo(item, index)"
          :key="index"
        >
          <img :src="item.ImageUrl" alt="" />
          <div>{{ item.Name }}</div>
        </div>
        <div
          class="tui-list-item"
          :style="{ background: FolderOneIndex == item.Id ? '#EAEAEA' : '' }"
          @contextmenu.prevent="updateFolderRightKey(index)"
          @click="selectFolder(item)"
          v-for="(item, index) in customFolderList"
          :key="index + 9"
        >
          <!-- <img v-if="item.ImageUrl" :src="item.ImageUrl" alt="" /> -->
          <img
            style="width: 96px; height: 70px"
            :src="
              item.ImageUrl == ''
                ? require('../../assets/folder-f0.png')
                : item.ImageUrl
            "
            alt=""
          />
          <div>{{ item.Name }}</div>
          <div class="operationPanel" v-if="item.isCheck">
            <div @click.stop="rechristen(item)">重命名</div>
            <div @click.stop="removeFolder(item)" style="color: red">删除</div>
          </div>
        </div>
      </div>
      <!-- 图片内容 -->
      <template v-if="currentIndex == 0">
        <template v-if="!isNoDate">
          <div
            class=""
            style="margin-top: 50px"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <div class="flex-items">
              <div class="tui-time">{{ item.time }}</div>
              <div class="tui-time-right">共{{ item.arr.length }}张</div>
            </div>
            <div class="imageList">
              <div
                style="margin-rigt: 10px; margin-bottom: 10px"
                v-for="(itemArr, indexArr) in item.arr"
                :key="indexArr"
              >
                <div>
                  <div :class="['image']" @click="checkimage(index, indexArr)">
                    <img :src="itemArr.FileUrl" alt="" />
                    <div class="ImageMask" v-if="itemArr.isCheck">
                      <img src="../../assets/check.png" alt="" />
                    </div>
                  </div>
                  <div
                    style="display: flex; cursor: pointer"
                    @click="previewImage(itemArr, index, indexArr)"
                  >
                    <i class="el-icon-view" style="font-size: 25px"></i>
                    <div
                      style="
                        font-size: 16px;
                        color: #333333;
                        padding-left: 10px;
                      "
                    >
                      预览
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty description="暂无数据" v-if="isNoDate"></el-empty>
      </template>
      <!-- 视频内容 -->
      <template v-if="currentIndex == 1">
        <template v-if="!isNoDate">
          <div
            class=""
            style="margin-top: 50px"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <div class="flex-items">
              <div class="tui-time">{{ item.time }}</div>
              <div class="tui-time-right">共{{ item.arr.length }}个视频</div>
            </div>
            <div class="imageList">
              <div
                style="margin-rigt: 10px; margin-bottom: 10px"
                v-for="(itemArr, indexArr) in item.arr"
                :key="indexArr"
              >
                <div>
                  <div :class="['image']" @click="checkimage(index, indexArr)">
                    <video :src="itemArr.FileUrl"></video>
                    <div class="ImageMask" v-if="itemArr.isCheck">
                      <img src="../../assets/check.png" alt="" />
                    </div>
                  </div>
                  <div
                    style="display: flex; cursor: pointer"
                    @click="preview(itemArr, index, indexArr)"
                  >
                    <i class="el-icon-view" style="font-size: 25px"></i>
                    <div
                      style="
                        font-size: 16px;
                        color: #333333;
                        padding-left: 10px;
                      "
                    >
                      预览
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty description="暂无数据" v-if="isNoDate"></el-empty>
      </template>
      <!-- 档案内容 -->
      <template v-if="currentIndex == 2">
        <div class="tui-titleName">幼儿电子档案</div>
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="FileName" label="档案名称" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="上传时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="wenDangDload(scope.row)"
                >下载</el-button
              >
              <el-button
                type="text"
                style="color: #e14747"
                @click="removeFile(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 报告内容 -->
      <template v-if="currentIndex == 3">
        <div class="flex" style="margin-top: 20px">
          <div
            class="tui-tabBtn"
            :class="btnsIndex == index ? 'tui-btns' : ''"
            v-for="(item, index) in btns"
            :key="item.name"
            @click="onClickBtns(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <el-table
          :data="evaluateTableData"
          style="width: 100%; margin-top: 20px"
          border
        >
          <el-table-column prop="date" label="报告名称" align="center">
          </el-table-column>
          <el-table-column prop="name" label="上传时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="wenDangDload(scope.row)"
                >下载</el-button
              >
              <el-button
                type="text"
                style="color: #e14747"
                @click="removeFile(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-card>
    <div class="tui-add" v-if="currentIndex != 3">
      <input
        @input="addFileChange"
        multiple="multiple"
        type="file"
        name=""
        id=""
      />
      <img src="../../assets/cloud-add.png" alt="" />
    </div>
    <!-- 预览 -->
    <el-dialog
      title="预览"
      :visible.sync="dialogVisible"
      width="440px"
      :before-close="handleClosePreview"
      :close-on-click-modal="true"
      :destroy-on-close="true"
    >
      <div class="preview">
        <el-image
          v-if="previewInfo.type == 'image'"
          style="width: 400px; height: auto"
          :src="previewInfo.FileUrl"
          fit="cover"
        ></el-image>
        <video
          style="width: 400px; height: auto"
          v-if="previewInfo.type == 'video'"
          :src="previewInfo.FileUrl"
          controls
          autoplay
        ></video>
        <div class="tui-preiveImg">
          <i
            @click="prevOne"
            class="el-icon-arrow-left"
            style="font-size: 25px; color: #000"
          ></i>
          <i
            class="el-icon-arrow-right"
            @click="NextOne"
            style="font-size: 25px; color: #000"
          ></i>
        </div>
        <div class="btnBox">
          <el-button @click="wenDangDload(previewInfo)" type="primary">
            下载
          </el-button>
          <el-button @click="addElseFileSingle(previewInfo)" type="primary">
            添加到
          </el-button>
          <el-button @click="removeFileSingle(previewInfo)" type="danger">
            删除
          </el-button>
          <el-button
            type="primary"
            v-if="FolderOneIndex != -0.1"
            @click="shiftOut(previewInfo)"
          >
            移出
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 添加到其他文件夹 -->
    <el-dialog
      title="添加到"
      :visible.sync="addElseFolderDialogVisible"
      :close-on-click-modal="true"
      @close="addElseFolderDialogClose"
      width="900px"
    >
      <!--  -->
      <div class="folderList">
        <template v-for="(item, index) in folderList">
          <div
            v-if="item.Id != FolderOneIndex"
            :class="[
              'folderItem',
              addFolderObj.addElseFolderId == item.Id ? 'FolderOneActive' : '',
            ]"
            @click="selectElseFolder(item)"
            :key="index"
          >
            <img class="folderIcon" :src="item.ImageUrl" alt="" />

            <div class="folderName">{{ item.Name }}</div>
          </div>
        </template>
        <!-- @click="selectFolder(item)" -->
        <template v-for="(item, index) in customFolderList">
          <div
            v-if="item.Id != FolderOneIndex"
            :class="[
              'folderItem',
              addFolderObj.addElseFolderId == item.Id ? 'FolderOneActive' : '',
            ]"
            @click="selectElseFolder(item)"
            :key="index + 9"
          >
            <!-- <img v-if="item.ImageUrl" :src="item.ImageUrl" alt="" /> -->
            <img
              class="folderIcon"
              :src="
                item.ImageUrl == ''
                  ? require('../../assets/folder-f0.png')
                  : item.ImageUrl
              "
              alt=""
            />
            <div class="folderName">{{ item.Name }}</div>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addElseFolderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="affirmAddElseFolder()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新建文件夹 -->
    <el-dialog
      title="新建相册"
      :visible.sync="addFolderDialogVisible"
      width="440px"
      :close-on-click-modal="true"
      :destroy-on-close="false"
    >
      <el-input
        v-model="addFolderObj.addFolderName"
        placeholder="请输入相册名称"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFolderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="affirmFolder()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 重命名 -->
    <el-dialog
      title="重命名"
      :visible.sync="UpdateFolderDialogVisible"
      width="440px"
      :close-on-click-modal="true"
      :destroy-on-close="false"
    >
      <p class="dialogTitle">相册名称</p>
      <el-input
        v-model="addFolderObj.updateFolderName"
        placeholder="请输入相册名称"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelRechristen()">取 消</el-button>
        <el-button type="primary" @click="affirmUpdateFolder()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  AddCloudFile,
  UploadFile,
  GetCloudFileByFolderId,
  DeleteCloudFile,
  UpdateCloudFileType,
  AddCloudFileType,
  GetCloudFileType,
  DeleteCloudFileType,
  UpdateCloudFileTypeName,
  GetCloudFilePageingByFolderId,
} from "../../api/api";
import download from "../../downLoad";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      tabs: [
        {
          name: "照片",
          icon: "el-icon-picture-outline",
        },
        {
          name: "视频",
          icon: "el-icon-video-camera",
        },
        // ,
        // {
        //   name: "档案",
        //   icon: "el-icon-postcard",
        // },
        // {
        //   name: "评价报告",
        //   icon: "el-icon-reading",
        // },
      ],
      isNoDate: false,
      folderList: [
        {
          Id: -0.1,
          Name: "未分类",
          ImageUrl: require("../../assets/weifenlei.png"),
        },
        {
          Id: -1.1,
          Name: "健康与体能",
          ImageUrl: require("../../assets/folder-f1.png"),
        },
        {
          Id: -2.1,
          Name: "习惯与自理",
          ImageUrl: require("../../assets/folder-f1.png"),
        },
        {
          Id: -3.1,
          Name: "自我与社会性",
          ImageUrl: require("../../assets/folder-f1.png"),
        },
        {
          Id: -4.1,
          Name: "语言与交流",
          ImageUrl: require("../../assets/folder-f1.png"),
        },
        {
          Id: -5.1,
          Name: "探究与认知",
          ImageUrl: require("../../assets/folder-f1.png"),
        },
        {
          Id: -6.1,
          Name: "美感与表现",
          ImageUrl: require("../../assets/folder-f1.png"),
        },
      ],
      currentIndex: 0,
      listInfo: {},
      folderIndex: 0,
      fileList: [],
      userInfo: {},
      FolderOneIndex: -0.1,
      dialogVisible: false,
      addElseFolderDialogVisible: false,
      addFolderDialogVisible: false,
      UpdateFolderDialogVisible: false,
      previewInfo: {},
      customFolderList: [],
      addFolderObj: {
        addFolderName: "",
        updateFolderName: "",
        updateFolderId: "",
        addElseFolderId: "",
      },
      tableData: [],
      btns: [
        {
          name: "学期报告",
        },
        {
          name: "家长报告",
        },
        {
          name: "过程报告",
        },
      ],
      btnsIndex: 0,
      evaluateTableData: [],
    };
  },
  computed: {
    checkArr() {
      let result = [];
      this.fileList.forEach((item) => {
        item.arr.forEach((itemTwo) => {
          if (itemTwo.isCheck) {
            result.push(itemTwo);
          }
        });
      });
      return result;
    },
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.listInfo = JSON.parse(this.$route.query.listInfo);
    if (this.listInfo.TypeName) {
      this.GetCloudFilePageingByFolderId();
    } else {
      if (this.listInfo.Cloud_FolderId == 0) {
        this.AddCloudFolder();
      } else {
        this.GetCloudFileByFolderId();
      }
    }
    this.GetCloudFileType();
  },
  methods: {
    async GetCloudFilePageingByFolderId() {
      let xhr = await GetCloudFilePageingByFolderId({
        StudentId: 0,
        Dimension:
          this.FolderOneIndex <= 0
            ? Math.floor(Math.abs(this.FolderOneIndex))
            : 9,
        Mu_Cloud_File_TypeId:
          this.FolderOneIndex <= 0 ? undefined : this.FolderOneIndex,
        GradeId: this.listInfo.GradeId,
        ClassId: this.listInfo.ClassId,
        SchoolId: this.userInfo.SchoolId,
        IsClassFolder: this.listInfo.IsClassFolder,
        FolderId: this.listInfo.Cloud_FolderId,
        Type: this.currentIndex + 1,
        PageIndex: 1,
        PageSize: 10000,
      });
      let resule = [];

      if (xhr.data.success) {
        if (this.currentIndex == 2) {
          this.tableData = xhr.data.response.data;
        } else {
          xhr.data.response.data.forEach((element) => {
            element.initDate = this.InitDate(element.CreateTime);
            let flieNameArr = element.FileUrl.split("/");
            element.flieName = flieNameArr[flieNameArr.length - 1];
            element.isCheck = false;
            let indexFlag = -1;
            for (let index = 0; index < resule.length; index++) {
              const item = resule[index];
              if (item.time == element.initDate) {
                indexFlag = index;
                break;
              }
            }
            if (indexFlag == -1) {
              resule.push({
                time: element.initDate,
                arr: [element],
              });
            } else {
              resule[indexFlag].arr.push(element);
            }
          });

          this.fileList = resule;
          if (this.fileList.length == 0) {
            this.isNoDate = true;
          } else {
            this.isNoDate = false;
          }
        }
      } else {
        this.isNoDate = true;
      }
    },
    onClickBtns(index) {
      this.btnsIndex = index;
      if (this.listInfo.TypeName) {
        this.GetCloudFilePageingByFolderId();
      } else {
        if (this.listInfo.Cloud_FolderId == 0) {
          this.AddCloudFolder();
        } else {
          this.GetCloudFileByFolderId();
        }
      }
    },
    //  删除文件提示
    removeFile(item, index) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await DeleteCloudFile({
            ids: [item.Id],
          });
          if (xhr.status == 200 && xhr.data.success) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            if (this.listInfo.TypeName) {
              this.GetCloudFilePageingByFolderId();
            } else {
              if (this.listInfo.Cloud_FolderId == 0) {
                this.AddCloudFolder();
              } else {
                this.GetCloudFileByFolderId();
              }
            }
          } else {
            this.$message({
              message: "删除失败",
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 预览视频
    preview(item, index, indexTwo) {
      this.dialogVisible = true;
      this.previewInfo = {
        type: "video",
        FileUrl: item.FileUrl,
        Id: item.Id,
        index: index,
        indexTwo,
      };
    },
    // 多个移出
    async shiftOutMore() {
      let arr = [];
      this.checkArr.forEach((item) => {
        arr.push(item.Id);
      });
      let xhr = await UpdateCloudFileType({
        Dimension: 0,
        CloudFileIds: arr,
      });
      if (xhr.data.success) {
        this.$message({
          message: "移出成功",
          type: "success",
        });
        if (this.listInfo.TypeName) {
          this.GetCloudFilePageingByFolderId();
        } else {
          if (this.listInfo.Cloud_FolderId == 0) {
            this.AddCloudFolder();
          } else {
            this.GetCloudFileByFolderId();
          }
        }
      } else {
        this.$$message({
          message: xhr.data.msg,
          type: "error",
        });
      }
    },
    //  添加到其他文件夹
    addElseFolder() {
      this.addElseFolderDialogVisible = true;
      let arr = [];
      this.checkArr.forEach((item) => {
        arr.push(item.Id);
      });
      sessionStorage.setItem("addElseFolder", JSON.stringify({ info: arr }));
    },
    // 批量删除
    async batchRemoveFolder() {
      let arr = [];
      this.checkArr.forEach((item) => {
        arr.push(item.Id);
      });
      let xhr = await DeleteCloudFile({
        ids: arr,
      });
      if (xhr.status == 200 && xhr.data.success) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        if (this.listInfo.TypeName) {
          this.GetCloudFilePageingByFolderId();
        } else {
          if (this.listInfo.Cloud_FolderId == 0) {
            this.AddCloudFolder();
          } else {
            this.GetCloudFileByFolderId();
          }
        }
      } else {
        this.$message({
          message: "删除失败",
          type: "error",
        });
      }
    },
    // 批量下载图片 或批量下载视频
    downloadAllImage() {
      let result = [];
      this.fileList.forEach((item) => {
        item.arr.forEach((itemTwo) => {
          if (itemTwo.isCheck) {
            result.push(itemTwo);
          }
        });
      });
      let urlArr = [];
      let imagenameArr = [];
      result.forEach((item) => {
        urlArr.push(item.FileUrl);
        imagenameArr.push(item.Name);
      });
      if (result.length == 0) {
        this.$message({
          message: "请选择文件",
          type: "warning",
        });
        return;
      }
      if (this.menuIndex == 2) {
        this.downImg(urlArr, imagenameArr);
      } else {
        result.forEach((item) => {
          let idx = item.FileUrl.lastIndexOf(".");

          if (idx != -1) {
            let ext = item.FileUrl.substr(idx + 1).toUpperCase();
            ext = ext.toLowerCase();
            this.downloadfile(item.FileUrl, item.Name, ext);
          }
        });
      }
    },
    // 将选择的图片压缩打包并下载
    downImg(arr, imgNameList) {
      var blogTitle = "打包图片";
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = ["./img1.png", "./img2.png", "./img3.png"];
      // 下载后图片的文件名，个数应与arr对应
      // var imgNameList = ["图片1", "图片2", "图片3"];

      for (var i = 0; i < arr.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);

          let url = canvas.toDataURL(); // 得到图片的base64编码数据
          canvas.toDataURL("image/png");

          baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
          if (baseList.length === arr.length && baseList.length > 0) {
            for (let k = 0; k < baseList.length; k++) {
              imgs.file(imgNameList[k] + ".png", baseList[k], { base64: true });
            }
            zip.generateAsync({ type: "blob" }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, blogTitle + ".zip");
            });
          }
        };
        image.src = arr[i];
      }
    },
    cancelRechristen() {
      this.customFolderList.forEach((item, customFolderIndex) => {
        item.isCheck = false;
      });
      this.UpdateFolderDialogVisible = false;
    },
    // 确认重命名
    affirmUpdateFolder() {
      if (this.addFolderObj.updateFolderName.length > 8) {
        this.$message({
          message: "请将文件名保持在8个字以内",
          type: "warning",
        });
        return;
      }
      UpdateCloudFileTypeName({
        name: this.addFolderObj.updateFolderName,
        id: this.addFolderObj.updateFolderId,
      }).then(
        (xhr) => {
          if (xhr.data.success) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.GetCloudFileType();
            this.UpdateFolderDialogVisible = false;
          } else {
            this.$message({
              message: xhr.data.msg,
              type: "error",
            });
          }
        },
        () => {}
      );
    },
    // 重命名
    rechristen(item) {
      this.addFolderObj.updateFolderId = item.Id;
      this.addFolderObj.updateFolderName = item.Name;
      this.UpdateFolderDialogVisible = true;
    },
    // 删除文件夹
    removeFolder(item) {
      const h = this.$createElement;
      this.$msgbox({
        title: "删除文件夹确认",
        message: h("p", null, [
          h("p", { style: "color: #D31F1F" }, "请确认是否删除此文件夹"),
          h("p", "一旦删除不可恢复，文件夹内包含的文件将转移至未分类文件夹"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            DeleteCloudFileType({
              id: item.Id,
            }).then(
              (xhr) => {
                if (xhr.data.success) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });
                  this.GetCloudFileType();
                  this.fileList = [];
                  this.FolderOneIndex = -0.1;
                  if (this.listInfo.TypeName) {
                    this.GetCloudFilePageingByFolderId();
                  } else {
                    if (this.listInfo.Cloud_FolderId == 0) {
                      this.AddCloudFolder();
                    } else {
                      this.GetCloudFileByFolderId();
                    }
                  }
                  done();
                } else {
                  this.$message({
                    message: xhr.data.msg,
                    type: "error",
                  });
                }
              },
              () => {}
            );
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    // 文件夹右键
    updateFolderRightKey(index) {
      this.customFolderList.forEach((item, customFolderIndex) => {
        if (index == customFolderIndex) {
          item.isCheck = !item.isCheck;
        } else {
          item.isCheck = false;
        }
      });
    },
    // 选择文件夹
    selectFolder(item) {
      this.FolderOneIndex = item.Id;
      if (this.listInfo.TypeName) {
        this.GetCloudFilePageingByFolderId();
      } else {
        if (this.listInfo.Cloud_FolderId == 0) {
          this.AddCloudFolder();
        } else {
          this.GetCloudFileByFolderId();
        }
      }
    },
    // 获取文件夹列表
    async GetCloudFileType() {
      let xhr = await GetCloudFileType({
        IsTeacher: 0, //this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
        uid: this.listInfo.TypeName ? 0 : this.listInfo.CustomerId,
        studentId: this.listInfo.TypeName ? 0 : this.listInfo.CustomerId,
        GradeId: this.listInfo.GradeId,
        ClassId: this.listInfo.ClassId,
        SchoolId: this.userInfo.SchoolId,
      });
      if (xhr.data.success) {
        xhr.data.response.forEach((item) => {
          item.isCheck = false;
        });
        this.customFolderList = xhr.data.response;
      }
    },
    // 新增文件夹
    async affirmFolder() {
      if (this.addFolderObj.addFolderName.length > 8) {
        this.$message({
          message: "请将文件名保持在8个字以内",
          type: "warning",
        });
        return;
      }
      let xhr = await AddCloudFileType({
        name: this.addFolderObj.addFolderName,
        customerId: this.listInfo.CustomerId,
        GradeId: this.listInfo.GradeId,
        ClassId: this.listInfo.ClassId,
        SchoolId: this.userInfo.SchoolId,
        IsTeacher: 0, // this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
      });
      if (xhr.data.success) {
        this.$message({
          message: "新增成功",
          type: "success",
        });
        this.GetCloudFileType();
        this.addFolderDialogVisible = false;
        this.addFolderObj.addFolderName = "";
      } else {
        this.$message({
          message: xhr.data.msg,
          type: "error",
        });
      }
    },
    addFolder() {
      this.addFolderDialogVisible = true;
    },
    // 确认移除到其他文件夹
    async affirmAddElseFolder() {
      //  sessionStorage.setItem("addElseFolder", JSON.stringify({ info: arr }));
      let addElseFolder = JSON.parse(sessionStorage.getItem("addElseFolder"));
      let xhr = await UpdateCloudFileType({
        Dimension:
          this.addFolderObj.addElseFolderId <= 0
            ? Math.floor(Math.abs(this.addFolderObj.addElseFolderId))
            : 9,
        Mu_Cloud_File_TypeId:
          this.addFolderObj.addElseFolderId <= 0
            ? undefined
            : this.addFolderObj.addElseFolderId,
        CloudFileIds: addElseFolder.info,
      });
      if (xhr.data.success) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.addElseFolderDialogVisible = false;
        this.dialogVisible = false;
        if (this.listInfo.TypeName) {
          this.GetCloudFilePageingByFolderId();
        } else {
          if (this.listInfo.Cloud_FolderId == 0) {
            this.AddCloudFolder();
          } else {
            this.GetCloudFileByFolderId();
          }
        }
      } else {
        this.$$message({
          message: xhr.data.msg,
          type: "error",
        });
      }
    },
    // 添加到其他文件夹选择
    selectElseFolder(item) {
      this.addFolderObj.addElseFolderId = item.Id;
    },
    // 单个添加到
    addElseFileSingle() {
      sessionStorage.setItem(
        "addElseFolder",
        JSON.stringify({ info: [this.previewInfo.Id] })
      );
      this.addElseFolderDialogVisible = true;
    },
    addElseFolderDialogClose() {
      this.addFolderObj.addElseFolderId = "";
    },
    // 预览中删除多个
    removeFileSingle() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await DeleteCloudFile({
            ids: [this.previewInfo.Id],
          });
          if (xhr.status == 200 && xhr.data.success) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.dialogVisible = false;
            if (this.listInfo.TypeName) {
              this.GetCloudFilePageingByFolderId();
            } else {
              if (this.listInfo.Cloud_FolderId == 0) {
                this.AddCloudFolder();
              } else {
                this.GetCloudFileByFolderId();
              }
            }
          } else {
            this.$message({
              message: "删除失败",
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 下载单个文件
    wenDangDload(item) {
      let idx = item.FileUrl.lastIndexOf(".");
      if (idx != -1) {
        let ext = item.FileUrl.substr(idx + 1).toUpperCase();
        ext = ext.toLowerCase();
        this.downloadfile(item.FileUrl, item.FileName, ext);
      }
    },
    downloadfile(url, strFileName, strMimeType) {
      var xmlHttp = null;
      if (window.ActiveXObject) {
        // IE6, IE5 浏览器执行代码
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
        xmlHttp = new XMLHttpRequest();
      }
      //2.如果实例化成功，就调用open（）方法：
      if (xmlHttp != null) {
        xmlHttp.open("get", url, true);
        xmlHttp.responseType = "blob"; //关键
        xmlHttp.send();
        xmlHttp.onreadystatechange = doResult; //设置回调函数
      }
      function doResult() {
        if (xmlHttp.readyState == 4) {
          //4表示执行完成
          if (xmlHttp.status == 200) {
            //200表示执行成功

            download(xmlHttp.response, strFileName, strMimeType);
          }
        }
      }
    },
    // 预览图片
    previewImage(item, index, indexTwo) {
      this.dialogVisible = true;
      this.previewInfo = {
        type: "image",
        FileUrl: item.FileUrl,
        Id: item.Id,
        index: index,
        indexTwo,
      };
    },
    // 选择图片或视频
    checkimage(index, indexTwo) {
      this.fileList[index].arr[indexTwo].isCheck =
        !this.fileList[index].arr[indexTwo].isCheck;
    },
    // 获得文件列表
    async GetCloudFileByFolderId(e) {
      this.fileList = [];
      let xhr = await GetCloudFileByFolderId({
        IsTeacher: 0, //this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
        FolderId: this.listInfo.Cloud_FolderId,
        Type: this.currentIndex + 1,
        Dimension:
          this.FolderOneIndex <= 0
            ? Math.floor(Math.abs(this.FolderOneIndex))
            : 9,
        Mu_Cloud_File_TypeId:
          this.FolderOneIndex <= 0 ? undefined : this.FolderOneIndex,
        Name:
          this.currentIndex == 3 ? this.btns[this.btnsIndex].name : undefined,
      });
      let resule = [];

      if (xhr.status == 200 && xhr.data.success) {
        if (this.currentIndex == 2) {
          this.tableData = xhr.data.response;
        } else {
          xhr.data.response.forEach((element) => {
            element.initDate = this.InitDate(element.CreateTime);
            let flieNameArr = element.FileUrl.split("/");
            element.flieName = flieNameArr[flieNameArr.length - 1];
            element.isCheck = false;
            let indexFlag = -1;
            for (let index = 0; index < resule.length; index++) {
              const item = resule[index];
              if (item.time == element.initDate) {
                indexFlag = index;
                break;
              }
            }
            if (indexFlag == -1) {
              resule.push({
                time: element.initDate,
                arr: [element],
              });
            } else {
              resule[indexFlag].arr.push(element);
            }
          });

          this.fileList = resule;
          if (this.fileList.length == 0) {
            this.isNoDate = true;
          } else {
            this.isNoDate = false;
          }
        }
      } else {
        this.isNoDate = true;
      }
    },
    InitDate(e) {
      let date = new Date(e);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;

      return y + "-" + m + "-" + d;
    },
    // 上传云文件判断
    addFileChange(event) {
      let file = event.target.files;
      for (let i = 0; i < file.length; i++) {
        //    上传类型判断
        let imgName = file[i].name;
        let idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          let ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();

          if (this.currentIndex == 0) {
            // 上传图片
            if (ext == "jpeg" || ext == "jpg" || ext == "png") {
            } else {
              this.$message({
                message: "请上传jpeg、jpg、png类型的图片",
                type: "error",
              });
              return;
            }
          } else if (this.currentIndex == 1) {
            //上传视频  AVI、mov、rmvb、rm、FLV、mp4、3GP
            if (
              ext == "avi" ||
              ext == "mov" ||
              ext == "rmvb" ||
              ext == "rm" ||
              ext == "flv" ||
              ext == "3gp" ||
              ext == "mp4"
            ) {
            } else {
              this.$message({
                message: "请上传 AVI、mov、rmvb、rm、FLV、mp4、3GP类型的视频",
                type: "error",
              });
              return;
            }
          } else if (this.currentIndex == 2) {
            if (ext == "doc" || ext == "docx" || ext == "pdf" || ext == "txt") {
            } else {
              this.$message({
                message: "请上传doc、docx、pdf、txt类型的文档",
                type: "error",
              });
              return;
            }
          }
        }
      }
      this.addFile(file);
    },
    // 上传云文件
    async addFile(flie) {
      if (!flie.length) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中。。。。。",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let result = [];
      let size = 0;
      try {
        for (let index = 0; index < flie.length; index++) {
          const element = flie[index];
          //定义FormData对象 存储文件
          let mf = new FormData();
          //将图片文件放入mf
          mf.append("file", element);
          let xhr = await UploadFile(mf);
          if (xhr.status == 200 && xhr.data.success) {
            // size+=element.size
            size += element.size;

            result.push({
              fileUrl: xhr.data.response,
              // name: element.name,
              FileName: element.name,
            });
          }
        }
      } catch (error) {
        // this.$message({
        //   message: "上传失败",
        //   type: "error",
        // });
      }

      let addXhr = await AddCloudFile({
        Storage: Math.round(size / 1024),
        IsTeacher: 0, //this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
        folderId: this.listInfo.Cloud_FolderId,
        customerId: this.listInfo.CustomerId,
        type: this.currentIndex + 1,
        cloudFileInfoList: result,
        pictureType: 3,
        schoolId: this.userInfo.SchoolId, //学校
        isNeedSearchFace: this.listInfo.isClass ? 1 : 0,
        Dimension:
          this.FolderOneIndex <= 0
            ? Math.floor(Math.abs(this.FolderOneIndex))
            : 9,
        Mu_Cloud_File_TypeId:
          this.FolderOneIndex <= 0 ? undefined : this.FolderOneIndex,
        // year: this.childInfo.Year,
      });
      if (addXhr.data.success) {
        if (this.listInfo.TypeName) {
          this.GetCloudFilePageingByFolderId();
        } else {
          if (this.listInfo.Cloud_FolderId == 0) {
            this.AddCloudFolder();
          } else {
            this.GetCloudFileByFolderId();
          }
        }
        this.$message({
          message: "上传成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "上传失败",
          type: "error",
        });
      }
      loading.close();
    },
    // 选择文件夹
    onClickInfo(item, index) {
      this.FolderOneIndex = item.Id;
      this.folderIndex = index;
      if (this.listInfo.TypeName) {
        this.GetCloudFilePageingByFolderId();
      } else {
        if (this.listInfo.Cloud_FolderId == 0) {
          this.AddCloudFolder();
        } else {
          this.GetCloudFileByFolderId();
        }
      }
    },
    onClickTabs(index) {
      this.currentIndex = index;
      this.customFolderList.forEach((item, customFolderIndex) => {
        item.isCheck = false;
      });
      this.fileList = [];
      if (this.currentIndex == 0) {
        this.fileType = 1;
      } else if (this.currentIndex == 1) {
        this.fileType = 2;
      } else if (this.currentIndex == 2) {
        this.fileType = 3;
      } else if (this.currentIndex == 3) {
        this.fileType = 4;
      }
      if (this.listInfo.TypeName) {
        this.GetCloudFilePageingByFolderId();
      } else {
        if (this.listInfo.Cloud_FolderId == 0) {
          this.AddCloudFolder();
        } else {
          this.GetCloudFileByFolderId();
        }
      }
    },

    handleClosePreview() {
      this.dialogVisible = false;
    },
    // 下一张
    NextOne() {
      let indexTwo = this.previewInfo.indexTwo + 1;
      let index = this.previewInfo.index;
      if (this.fileList[this.previewInfo.index].arr.length - 1 < indexTwo) {
        indexTwo = 0;
        index += 1;
        if (index > this.fileList.length - 1) {
          index = 0;
          indexTwo = 0;
          this.$message.warning("没有下一张了");
          return;
        }
      }
      let item = this.fileList[index].arr[indexTwo];
      this.previewInfo = {
        type: this.previewInfo.type,
        FileUrl: item.FileUrl,
        Id: item.Id,
        index: index,
        indexTwo,
      };
    },
    // 上一张
    prevOne() {
      let indexTwo = this.previewInfo.indexTwo - 1;
      let index = this.previewInfo.index;
      if (indexTwo < 0) {
        indexTwo = 0;
        index -= 1;
        if (index < 0) {
          index = this.fileList.length - 1;
          indexTwo = this.fileList[this.fileList.length - 1].arr.length - 1;
          this.$message.warning("没有上一张了");
          return;
        }
      }
      let item = this.fileList[index].arr[indexTwo];
      this.previewInfo = {
        type: this.previewInfo.type,
        FileUrl: item.FileUrl,
        Id: item.Id,
        index: index,
        indexTwo,
      };
    },
  },
};
</script>
<style scoped lang="less">
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-tabBtn {
  width: 92px;
  height: 30px;
  background: #ffffff;
  border-radius: 3px;
  border: 1px solid #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-right: 20px;
  cursor: pointer;
}
.tui-btns {
  background: #5474e6 !important;
  color: #fff !important;
}
.tui-titleName {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.dialogTitle {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 48px;
}
.operationPanel {
  position: absolute;
  z-index: 2;
  width: 163px;
  // height: 154px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 3px rgba(74, 138, 201, 0.1);
  border-radius: 10px;
  left: 50%;
  top: 50%;
  cursor: pointer;
  div {
    text-align: center;
    font-size: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0 !important;
  }
}
.operationPanel div:nth-child(1) {
  border-bottom: 1px solid #999999;
}
.operationPanel div:nth-child(2) {
  color: #dd2d2d;
}
.folderList {
  display: flex;
  flex-wrap: wrap;
  .FolderOneActive {
    background-color: #eaeaea !important;
  }
  .folderItem {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 115px;
    height: 150px;
    margin: 13px;
    position: relative;

    .folderIcon {
      // width: 136px;
      width: 90px;

      height: 58px;

      // height: 87px;
      margin: 0 auto;
      // margin-top: 11px;
      margin-top: 6px;
      display: block;
    }
    .folderName {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 300;
      color: #666666;
      text-align: center;
      padding-top: 5px;
    }
  }
}
.btnBox {
  text-align: center;
  width: 100%;
  padding-top: 30px;
}
.preview {
  position: relative;
}
.tui-preiveImg {
  width: 100%;
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.imageList {
  display: flex;
  flex-wrap: wrap;
  // .check {
  //   border: solid 3px #409eff !important;
  // }
  .image {
    margin: 10px 10px 10px 0;
    width: 102px;
    height: 102px;
    position: relative;
    background: #cccccc;
    cursor: pointer;
    border: 3px solid #fff;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    video {
      width: 100%;
      height: 100%;
    }
    .ImageMask {
      width: 102px;
      height: 102px;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 3;
      img {
        width: 26px;
        position: absolute;
        height: auto;
        top: 3px;
        right: 3px;
      }
    }
    .mask {
      width: 102px;
      height: 102px;
      position: absolute;
      top: 0;
      left: 0;
      // background: rgba(0, 0, 0, 0.4);
      z-index: 2;
      img {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    }
    .content {
      z-index: 1;
      position: absolute;
      width: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
}
.tui-time {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.tui-time-right {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding-left: 50px;
}
.tui-add {
  position: fixed;
  bottom: 53px;
  right: 102px;
  input {
    cursor: pointer;
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}
.tui-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 50px;
  .tui-list-item {
    width: calc(100% / 9 - 10px);
    height: 150px;

    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
    margin-top: 10px;
    cursor: pointer;
    position: relative;
    div {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      padding-top: 10px;
      //   line-height: 20px;
    }
  }
  // .tui-list-item:nth-child(1) {
  //   border-right: 1px #cdcdcd solid;
  // }
  .tui-list-item:nth-of-type(9) {
    margin-right: 0;
  }
}
.tui-title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  padding-right: 10px;
}
.tui-tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .tui-tab-item {
    font-size: 16px;
    font-weight: 500;
    color: #666;
    cursor: pointer;
    padding: 0 40px;
  }
  .tui-active {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 20px;
  }
}
</style>